<div
  [ngClass]="{
    'error-message': note.noteType === noteTypeError,
    'information-message': note.noteType === noteTypeInformation,
    'waiting-message': note.noteType === noteTypeWaiting,
    'warning-message': note.noteType === noteTypeWarning,
  }"
>
  <div class="message-content">
    @if (note.noteType === noteTypeError) {
      <mat-icon class="error-icon s-30">error</mat-icon>
    }
    @if (note.noteType === noteTypeInformation) {
      <mat-icon class="information-icon s-30" svgIcon="svg_done"></mat-icon>
    }
    @if (note.noteType === noteTypeWaiting) {
      <mat-icon class="s-30 waiting-icon" svgIcon="svg_waiting"></mat-icon>
    }
    @if (note.noteType === noteTypeWarning) {
      <mat-icon class="s-30 warning-icon">warning</mat-icon>
    }
    <div class="message-text fxl-column fxla-start-center">
      <span>{{ note.message }}</span>
      @if (note.messageLine2) {
        <span>{{ note.messageLine2 }}</span>
      }
      @if (note.linkLabel) {
        <a (click)="performAction()" class="m-4 action-link primary-fg fxsa-center"> {{ note.linkLabel }} </a>
      }
    </div>
  </div>
</div>
